import TableWrapper from "./components";
import "./App.css";

function App() {
  return (
    <div>
      <TableWrapper />
    </div>
  );
}

export default App;
